/** @module Camunda/TaskViewBatchHeader */
define([
	"dojo/_base/declare",
	"csi/html",
	"csi/locale",
	"csi/widget/MaterialIconWithLabel",
	"./TaskViewHeader"
], function(declare,html,locale,MaterialIconWithLabel,TaskViewHeader) {

	const KEY_COUNT = "count";
	const KEY_ICON = "icon";

	return declare(TaskViewHeader, {
		/** @property {Result} taskGroupResult - batched group query result */
		taskGroupResult: null,
		
		/**
		 * @override
		 * Custom processing of view keys
		 */
		_processKey: function(ctx, key, def, domNode) {
			const n = this.taskGroupResult.childResults.length;
			
			switch(key) {
				case KEY_COUNT:
					html.text(domNode, locale.resource("TaskBatchCount", [n]));
					break;

				case KEY_ICON:
					new MaterialIconWithLabel({
						className: "csi-camunda-tasks-batch-icon",
						icon: "filter_" + ((n > 9) ? "9_plus" : n),
						iconSize: 32
					}).placeAt(domNode);
					break;
					
				default:
					this.inherited(arguments);
					break;
			}
		}
	});
});
